const toggleIsSelected = (index, { setCarFeaturesList, setFeatures }) => {

  setCarFeaturesList(prevState => {
    const newList = [...prevState];

    newList[index] = {
      ...newList[index],
      isSelected: !newList[index].isSelected
    };

    const selectedFeatures = newList.filter(feature => feature.isSelected);
    setFeatures([...selectedFeatures]);

    return newList;
  });
};

export default toggleIsSelected;